<template>
  <div>
  <div class="page-container" v-if="flag">
    <el-card class="password-card" shadow="hover"  >
      <div class="card-title">修改密码</div>

      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="新密码">
          <el-input
            v-model="form.password"
            placeholder="请输入新密码"
            show-password
            clearable
          />
        </el-form-item>

        <el-form-item label="确认密码">
          <el-input
            v-model="form.password1"
            placeholder="请再次输入密码"
            show-password
            clearable
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            class="submit-btn"
            @click="submit"
          >
            提交修改
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
    <div v-if="!flag" class="success-container">
      <el-card class="success-card" shadow="hover">
        <i class="el-icon-success success-icon"></i>
        <div class="success-title">修改成功</div>
        <div class="success-desc">
          您的密码已成功更新，请使用新密码重新登录
        </div>

        <el-button
          type="primary"
          class="success-btn"
          @click="goBack"
        >
          返回
        </el-button>
      </el-card>
    </div>

  </div>
</template>

<script>
import axios from '../../utils/request'

export default {
  name: 'Config',
  data () {
    return {
      form: {
        password: '',
        password1: ''
      },
      flag: true
    }
  },
  methods: {
    submit () {
      if (!this.form.password || !this.form.password1) {
        this.$message.warning('请输入完整密码')
        return
      }

      if (this.form.password !== this.form.password1) {
        this.$message.error('两次输入的密码不一致')
        return
      }

      axios.get(`/data/changepassword?password=${this.form.password}`)
        .then(res => {
          this.$message.success('密码修改成功')
          this.flag = false
          console.log(res.data)
        })
    },
    goBack () {
      // 根据你的项目情况选择一个
      this.$router.push('/device/bind')
      // 或：this.flag = true
    }
  }
}
</script>

<style scoped>
  /* 页面整体 */
  .page-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(135deg, #f0f2f5, #e6f7ff);
  }

  /* 卡片 */
  .password-card {
    width: 420px;
    padding: 10px 20px 20px;
    border-radius: 10px;
  }

  /* 标题 */
  .card-title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 25px;
    color: #303133;
  }

  /* 提交按钮 */
  .submit-btn {
    width: 100%;
    height: 40px;
    font-size: 15px;
  }
  /* 成功页整体 */
  .success-container {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(135deg, #f0f2f5, #e6f7ff);
  }

  /* 成功卡片 */
  .success-card {
    width: 420px;
    text-align: center;
    padding: 30px 20px;
    border-radius: 12px;
  }

  /* 成功图标 */
  .success-icon {
    font-size: 64px;
    color: #67c23a;
    margin-bottom: 15px;
  }

  /* 成功标题 */
  .success-title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #303133;
  }

  /* 成功描述 */
  .success-desc {
    font-size: 14px;
    color: #909399;
    margin-bottom: 25px;
  }

  /* 按钮 */
  .success-btn {
    width: 100%;
    height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Config.vue